import { Box, Grid, Collapse, Card } from "@mui/material";

import { formatDateRange } from "../../../../../Utils/DateUtils";
import ActiveFilters from "../../../../../Components/filters/ActiveFilters";

import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
}) => {
  // Helper function to remove date range filters
  const handleRemoveDateRange = (rangeId) => {
    if (rangeId === "orderLoaded") {
      handleRemove("orderLoadedStart");
      handleRemove("orderLoadedEnd");
    } else if (rangeId === "orderReachedBay") {
      handleRemove("orderReachedBayStart");
      handleRemove("orderReachedBayEnd");
    } else if (rangeId === "orderMarkedCompleted") {
      handleRemove("orderMarkedCompletedStart");
      handleRemove("orderMarkedCompletedEnd");
    } else if (rangeId === "orderedDate") {
      handleRemove("orderedDateStart");
      handleRemove("orderedDateEnd");
    }
  };

  // Helper function to remove numeric range filters
  const handleRemoveNumericRange = (rangeId) => {
    if (rangeId === "orderLine") {
      handleRemove("orderLineMin");
      handleRemove("orderLineMax");
    }
  };

  // All filters in the order they appear
  const activeFilterDefinitions = [
    // Standard filters - in order
    {
      type: "standard",
      id: "jobNo",
      label: "Job No",
      value: submittedData.jobNo,
    },
    {
      type: "standard",
      id: "custOrder",
      label: "Cust Order",
      value: submittedData.custOrder,
    },
    {
      type: "numericRange",
      id: "orderLine",
      label: "Order Line",
      minValue: submittedData.orderLineMin,
      maxValue: submittedData.orderLineMax,
    },
    {
      type: "standard",
      id: "picker",
      label: "Picker",
      value: submittedData.picker,
    },
    {
      type: "standard",
      id: "timePeriod",
      label: "Time Period",
      value: submittedData.timePeriod,
    },
    {
      type: "dateRange",
      id: "orderedDate",
      label: "Ordered Date",
      startValue: submittedData.orderedDateStart,
      endValue: submittedData.orderedDateEnd,
    },
    {
      type: "dateRange",
      id: "orderLoaded",
      label: "Order Loaded",
      startValue: submittedData.orderLoadedStart,
      endValue: submittedData.orderLoadedEnd,
    },
    {
      type: "dateRange",
      id: "orderReachedBay",
      label: "Order Reached Bay",
      startValue: submittedData.orderReachedBayStart,
      endValue: submittedData.orderReachedBayEnd,
    },
    {
      type: "dateRange",
      id: "orderMarkedCompleted",
      label: "Order Marked Completed",
      startValue: submittedData.orderMarkedCompletedStart,
      endValue: submittedData.orderMarkedCompletedEnd,
    },
    {
      type: "standard",
      id: "totalDuration",
      label: "Total Duration",
      value: submittedData.totalDuration,
    },
  ];

  return (
    <Grid item xs={12}>
      <Collapse in={filterOpen}>
        <Card>
          <Box p={4}>
            <FilterItems
              filterData={filterData}
              handleChangeFilter={handleChangeFilter}
              handleFilter={handleFilter}
              handleClearFilters={handleClearFilters}
            />
          </Box>
        </Card>
      </Collapse>
      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
        onRemoveDateRange={handleRemoveDateRange}
        onRemoveNumericRange={handleRemoveNumericRange}
        formatDateRange={formatDateRange}
      />
    </Grid>
  );
};

export default Filter;
